import React, { useState } from "react";
import "../styles/ForgotPassword.css";

/* ─── Icons ─── */
const ConvertIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const LockIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default function ConvertProForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const API_URL =
    process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const response = await fetch(
        `${API_URL}/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
          },
          body: JSON.stringify({
            email
          }),
        }
      );

      const result =
        await response.json();

      alert(result.message);

      setSubmitted(true);

    } catch (error) {

      console.error(error);

      alert(
        "Unable to send reset email"
      );
    }
  };

  if (submitted) {
    return (
      <div className="fp-layout">
        <div className="fp-logo">
          <ConvertIcon />
          <span className="fp-logo-text">ConvertPro</span>
        </div>

        <div className="fp-card">
          <div className="fp-icon-circle fp-icon-circle--green">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <h1 className="fp-title">Check your email</h1>
          <p className="fp-subtitle">
            We've sent a password reset link to <strong className="fp-email">{email}</strong>.
            Click the link in the email to create a new password.
          </p>
          <button className="fp-btn-primary" onClick={() => setSubmitted(false)}>
            Send Again
          </button>
          <div className="fp-divider" />
          <p className="fp-back-text">
            <a href="#login" className="fp-link">Back to Sign In</a>
          </p>
        </div>

        <p className="fp-footer">© 2026 ConvertPro. All rights reserved.</p>
      </div>
    );
  }

  return (
    <div className="fp-layout">
      {/* Logo */}
      <div className="fp-logo">
        <ConvertIcon />
        <span className="fp-logo-text">ConvertPro</span>
      </div>

      {/* Card */}
      <div className="fp-card">
        <div className="fp-icon-circle">
          <LockIcon />
        </div>

        <h1 className="fp-title">Forgot your password?</h1>
        <p className="fp-subtitle">
          No worries — enter your email address and we'll send you a link to reset your password.
        </p>

        <form className="fp-form" onSubmit={handleSubmit}>
          <div className="fp-field">
            <label className="fp-label">Email Address</label>
            <input
              className="fp-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="fp-btn-primary">
            Send Reset Link
          </button>
        </form>

        <div className="fp-divider" />

        <p className="fp-back-text">
          Remember your password? <a href="#login" className="fp-link">Back to Sign In</a>
        </p>
      </div>

      {/* Footer */}
      <p className="fp-footer">© 2026 ConvertPro. All rights reserved.</p>
    </div>
  );
}
